var path = 'src/app/users/delete-user.html';
var html = "<div page-wrapper> <h1 class=page-header>Delete {{user.username}}?</h1> <p> Are you sure you want to delete <strong>{{user.username}}</strong>? In most cases you should disable the user instead. </p> <p> <button ng-disabled=user.isDeleting class=\"btn btn-danger\" ng-click=remove(user)> <i class=\"fa fa-trash-o\" ng-show=!user.isDeleting></i> <i class=\"fa fa-spinner fa-spin\" ng-show=user.isDeleting></i> Delete </button> </p> <p>Note: deletion will fail if any records in RaDaR reference this user. In this case you should disable the user instead.</p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/users/delete-user.html
 ** module id = 711
 ** module chunks = 0
 **/